/** 落地页 AI 执行池按模型服务商的并发槽数配置；运营在集成页按服务商调整，未配置取默认值。 */
import { z } from 'zod';
import { type LandingAiProvider, LandingAiProviderSchema } from './landing-ai-config';

/** 本机 Ollama 单卡只放 1 路；HF 云端按套餐常见并发取 3；其余云服务商沿用既有 1 路。 */
export const LANDING_AI_PROVIDER_CONCURRENCY_DEFAULTS = {
  openrouter: 1,
  bailian: 1,
  ollama: 1,
  huggingface: 3,
} as const satisfies Record<LandingAiProvider, number>;

export const LANDING_AI_PROVIDER_CONCURRENCY_MAX = 8;

export const LandingAiProviderConcurrencyValueSchema = z
  .number()
  .int('并发数须为整数')
  .min(1, `并发数须在 1–${LANDING_AI_PROVIDER_CONCURRENCY_MAX} 之间`)
  .max(
    LANDING_AI_PROVIDER_CONCURRENCY_MAX,
    `并发数须在 1–${LANDING_AI_PROVIDER_CONCURRENCY_MAX} 之间`,
  );

export const UpdateLandingAiProviderConcurrencyRequestSchema = z
  .object({
    provider: LandingAiProviderSchema,
    max_concurrency: LandingAiProviderConcurrencyValueSchema,
  })
  .strict();
export type UpdateLandingAiProviderConcurrencyRequest = z.infer<
  typeof UpdateLandingAiProviderConcurrencyRequestSchema
>;

/** 各服务商当前生效的并发槽数（已合并默认值）。 */
export type LandingAiProviderConcurrency = Record<LandingAiProvider, number>;
